import React, { useEffect, useRef } from "react";
import { InputTypeAhead, InputNumber } from "@loanbossinc/component-library";


import { checkIfHorizontalDividerNeeded } from "./helpers";
import { InputDropdownWrapper, InputTextWrapper, InputGroupLabel, InputGroupWrapper } from "./styles";

export const InputGroup = ({
  field,
  handleChange,
  calculationFieldsInputValues,
  setDscrLineItemSelections,
  fullWidth,
  lineItemType,
  comparisonGroup,
  shouldFocusOnOverrideInput
}) => {
  const { fieldName, fieldLabel, additionalFields, onlyDropdown, additionalFieldsName, additionalFieldsLabel } = field;
  const group = comparisonGroup === "first" ? "1" : "2";

  const inputRef = useRef(null);

  useEffect(() => {
    if (fieldLabel === "override hypothetical amortization rate?" && shouldFocusOnOverrideInput) {
      inputRef.current && inputRef.current.focus();
    }
  }, [fieldLabel, calculationFieldsInputValues, shouldFocusOnOverrideInput]);

  const getValue = () => {
    if (!calculationFieldsInputValues || !calculationFieldsInputValues.length) {
      return "";
    }

    return calculationFieldsInputValues.find((f) => f.fieldName === fieldLabel).inputValue;
  };

  const onAdditionalFieldChange = (selectedOption) => {
    const updatedFields =
      calculationFieldsInputValues &&
      calculationFieldsInputValues.map((f) => (f.fieldName === fieldLabel ? { ...f, additionalInputValue: selectedOption } : f));

      if (lineItemType !== "greaterOf") {
        setDscrLineItemSelections({ calculationFieldsInputValues: updatedFields });
      } else {
        setDscrLineItemSelections({ [`comparisonCalculationFieldsInputValues${group}`]: updatedFields , [`calculatedComparisonValue${group}`]: null});
      }
  };

  const getValueForAdditionalField = () => {
    const fieldWithAdditionalInput = calculationFieldsInputValues && calculationFieldsInputValues.find((f) => f.fieldName === fieldLabel);

    return fieldWithAdditionalInput?.additionalInputValue;
  };

  const shouldDisplayInputTextField = () => {
    if (onlyDropdown) {
      return false;
    }

    if (fieldLabel === "override hypothetical amortization rate?") {
      const shouldOverrideRate =
        calculationFieldsInputValues &&
        calculationFieldsInputValues.find((f) => f.fieldName === "override hypothetical amortization rate?")?.shouldOverrideRate;
      return shouldOverrideRate;
    }

    return true;
  };

  return (
    <InputGroupWrapper horizontalDivider={checkIfHorizontalDividerNeeded(fieldLabel)}>
      {fieldLabel !== "override hypothetical amortization rate?" && <InputGroupLabel>{fieldLabel}</InputGroupLabel>}
      {additionalFields && (
        <InputDropdownWrapper fullWidth={fullWidth}>
          <InputTypeAhead
            variant="filled"
            id="type"
            name={additionalFieldsName}
            label={additionalFieldsLabel}
            options={additionalFields}
            displayWith={(option) => option && option.type}
            setValueWith={(option) => option}
            onChange={onAdditionalFieldChange}
            value={getValueForAdditionalField()}
          />
        </InputDropdownWrapper>
      )}
      {shouldDisplayInputTextField() && (
        <InputTextWrapper fullWidth={fullWidth} noLabel>
          <InputNumber
            value={getValue()}
            variant="filled"
            id={fieldLabel}
            fullWidth
            decimals={4}
            type="number"
            name={fieldLabel}
            label={fieldName}
            onChange={handleChange}
            inputRef={inputRef}
          />
        </InputTextWrapper>
      )}
    </InputGroupWrapper>
  );
};
